import BlogGrid from '~/components/Slices/BlogGrid'
import HeroTitle from '~/components/Slices/HeroTitle'

import { ClientPageView } from '~/providers/GTMTrackingProvider/ClientPageView'

import { getBlogPageStaticProps } from '~/data/blog-page-data'
import { BlogPageData } from '~/data/blog-page-data/serializer'

function Blog({
  hero,
  navigation,
  items,
  pagination,
  previewRef,
}: BlogPageData) {
  return (
    <>
      <HeroTitle {...hero} />
      <BlogGrid
        navigation={navigation}
        items={items}
        pagination={pagination}
        previewRef={previewRef}
      />
      <ClientPageView template="blog" />
    </>
  )
}

export default Blog

export const getStaticProps = getBlogPageStaticProps()
